module.exports = __webpack_public_path__ + "img/event-main.93d9cfa2.svg";